var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwIconsArtboard58(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 102.78 102.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n        stroke-miterlimit: 10;\n        stroke-width: 1.35px;\n      }\n\n      .cls-2 {\n        stroke: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        stroke: url(#New_Gradient_Swatch_4);\n      }\n\n      .cls-4 {\n        stroke: url(#New_Gradient_Swatch_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3784.63,
    y1: 71.65,
    x2: -3853.06,
    y2: 71.65,
    gradientTransform: "translate(-3784.63) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    "data-name": "New Gradient Swatch 3",
    x1: -3887.41,
    y1: 31.12,
    x2: -3818.97,
    y2: 31.12,
    gradientTransform: "translate(-3784.63) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#5fc000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c8da00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    "data-name": "New Gradient Swatch 4",
    x1: 71.65,
    y1: 102.78,
    x2: 71.65,
    y2: 34.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0079ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ae2f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3583.14,
    y1: 2938.16,
    x2: -3514.7,
    y2: 2938.16,
    gradientTransform: "translate(-2907.03 3583.14) rotate(90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#830064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98b3fb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.27,59.16H13.16c-6.89,0-12.49,5.59-12.49,12.49,0,6.9,5.59,12.48,12.49,12.48h42.1c6.9,0,12.49-5.59,12.49-12.48,0-6.9-5.59-12.49-12.49-12.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.62,18.64h-42.11c-6.9,0-12.48,5.59-12.49,12.48,0,6.9,5.59,12.49,12.49,12.49h42.11c6.9,0,12.49-5.59,12.49-12.49,0-6.9-5.6-12.48-12.49-12.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.16,47.51v42.11c0,6.89,5.59,12.49,12.49,12.49,6.9,0,12.48-5.59,12.48-12.49v-42.1c0-6.9-5.59-12.49-12.48-12.49-6.9,0-12.49,5.59-12.49,12.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.64,13.16v42.11c0,6.9,5.59,12.48,12.48,12.49,6.9,0,12.49-5.59,12.49-12.49V13.16c0-6.9-5.59-12.49-12.49-12.49-6.9,0-12.48,5.6-12.48,12.49Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIconsArtboard58);
export default __webpack_public_path__ + "static/media/tw-icons-artboard-58.49e7f707625a0b01e9178924f23f46bc.svg";
export { ForwardRef as ReactComponent };